"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const d3 = tslib_1.__importStar(require("d3"));
const style_1 = tslib_1.__importDefault(require("../utils/style"));
const GraphComponent = ({ csvPath }) => {
    const graphContainerRef = react_1.useRef();
    const styleLocal = style_1.default();
    react_1.useEffect(() => {
        if (!csvPath)
            return;
        const fetchGraphData = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                // Fetch CSV file
                const response = yield fetch(csvPath);
                const csvText = yield response.text();
                // Parse CSV using D3
                const data = d3.csvParse(csvText);
                // Convert CSV adjacency matrix to nodes & links
                const nodes = Object.keys(data[0]).map((name) => ({ id: name }));
                const links = [];
                data.forEach((row, sourceIdx) => {
                    Object.keys(row).forEach((target, targetIdx) => {
                        if (row[target] === "1") {
                            links.push({ source: nodes[sourceIdx].id, target: nodes[targetIdx].id });
                        }
                    });
                });
                // Create a graph with D3
                createGraph(nodes, links);
            }
            catch (error) {
                console.error("Error loading CSV:", error);
            }
        });
        fetchGraphData();
    }, [csvPath]);
    const createGraph = (nodes, links) => {
        const width = 1000, // Set large width for scrollability
        height = 400;
        // Clear previous SVG
        d3.select(graphContainerRef.current).selectAll("*").remove();
        // Create SVG container
        const svg = d3
            .select(graphContainerRef.current)
            .append("svg")
            .attr("width", width) // Make it responsive
            .attr("height", height)
            .attr("viewBox", `0 0 ${width} ${height}`)
            .attr("preserveAspectRatio", "xMidYMid meet")
            .call(d3.zoom().on("zoom", (event) => {
            svg.attr("transform", event.transform);
        }))
            .append("g"); // Group to handle zooming
        // Define arrowhead marker
        svg.append("defs").selectAll("marker")
            .data(["arrowhead"]) // Only one type of marker for arrowhead
            .enter().append("marker")
            .attr("id", "arrowhead")
            .attr("viewBox", "0 -5 10 10")
            .attr("refX", 15) // Adjust the position of the arrowhead
            .attr("refY", 0)
            .attr("orient", "auto")
            .attr("markerWidth", 6)
            .attr("markerHeight", 6)
            .append("path")
            .attr("d", "M0,-5L10,0L0,5")
            .style("fill", "black");
        // Create force simulation
        const simulation = d3
            .forceSimulation(nodes)
            .force("link", d3.forceLink(links).id((d) => d.id).distance(100))
            .force("charge", d3.forceManyBody().strength(-200)) // Reduce repulsion
            .force("collide", d3.forceCollide().radius(40)) // Prevents overlap
            .force("x", d3.forceX(width / 2).strength(0.1)) // Center horizontally
            .force("y", d3.forceY(height / 2).strength(0.1)); // Center vertically
        // Draw links (edges)
        const link = svg
            .selectAll("line")
            .data(links)
            .enter()
            .append("line")
            .style("stroke", "black")
            .style("stroke-width", 2)
            .style("stroke-height", 100)
            .attr("marker-end", "url(#arrowhead)");
        // Draw nodes
        const node = svg
            .selectAll("circle")
            .data(nodes)
            .enter()
            .append("circle")
            .attr("r", 10)
            .attr("fill", "lightblue")
            .call(d3.drag().on("start", dragStart).on("drag", dragging).on("end", dragEnd));
        // Draw node labels
        svg
            .selectAll("text")
            .data(nodes)
            .enter()
            .append("text")
            .attr("dy", 4)
            .attr("text-anchor", "middle")
            .style("font-size", "10px")
            .text((d) => d.id);
        // Update simulation
        simulation.on("tick", () => {
            link
                .attr("x1", (d) => d.source.x)
                .attr("y1", (d) => d.source.y)
                .attr("x2", (d) => d.target.x)
                .attr("y2", (d) => d.target.y);
            node.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
            svg.selectAll("text")
                .attr("x", (d) => d.x) // Offset to avoid overlap
                .attr("y", (d) => d.y + 4);
        });
        function dragStart(event, d) {
            if (!event.active)
                simulation.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
        }
        function dragging(event, d) {
            d.fx = event.x;
            d.fy = event.y;
        }
        function dragEnd(event, d) {
            if (!event.active)
                simulation.alphaTarget(0);
            d.fx = undefined; // Instead of null
            d.fy = undefined;
        }
    };
    return (react_1.default.createElement("div", { ref: graphContainerRef, className: styleLocal.graphPlot },
        react_1.default.createElement("svg", { style: { display: "block" } })));
};
exports.default = GraphComponent;
//# sourceMappingURL=graph-component.js.map